<template>
  <div class="block">
    <div class="reorder">
      <a href="#" v-on:click="$emit('moveDown', data)" class="move-up">&uarr;</a>
      <a href="#" v-on:click="$emit('moveUp', data)" class="move-down">&darr;</a>
    </div>
    <a href="#" v-on:click="$emit('deleteBlock', data)" class="delete nested">x</a>
    <label class="underline">Text block</label>
    <div class="row">
      <div class="field">
        <label>Style</label>
        <div class="control">
          <select v-model="data.classNames" multiple>
            <option value="column-text">Column text (right)</option>
            <option value="centered">Centered</option>
            <option value="full-width">Full width</option>
          </select>
        </div>
        <div class="field">
          <label class="label">Background colour</label>
          <div class="control">
            <input class="input" type="text" placeholder="#cccccc" v-model="data.styles_background_colour" />
          </div>
        </div>
        <div class="field">
          <label class="label">Font colour</label>
          <div class="control">
            <input class="input" type="text" placeholder="#000000" v-model="data.styles_font_colour" />
          </div>
        </div>
      </div>
      <div class="field text-field">
        <label class="label">Text <span class="underline" v-on:click="htmlcontent = data.content; edithtml = !edithtml">HTML</span></label>
        <div class="control" style="position: relative">
          <div v-if="edithtml" class="html-edit">
            <div class="ql-toolbar ql-snow">
              <span style="cursor:pointer;" class="button" v-on:click="data.content = htmlcontent; edithtml = !edithtml; updated()">✔ Save</span>
            </div>
            <textarea v-model="htmlcontent"></textarea>
          </div>
          <vue-editor v-if="!edithtml" :id="'editor1-'+data.id" v-model="data.content"></vue-editor>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { firestore } from '../main'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'Edit-TextBlock',
  props: ['data'],
  data: function () {
    return {
      edithtml: false,
      htmlcontent: ''
    }
  },
  components: {
    VueEditor
  },
  beforeCreate: function() {
    if (!this.data.styles) this.data.styles = {}
  },
  updated: function() {
    if (!this.data) return
    this.$emit('updateBlock', this.data)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-field {
    flex: 2;
  }
  .html-edit {
    position: absolute;
    top: 0;
    left: 0;
    height: 400px;
    width: 100% !important;
    z-index: 1;
    display: flex;
    flex-direction: column;
  }
  .html-edit textarea {
    border: 1px solid #ccc;
    border-top: 0;
    resize: none;
    flex: 1;
  }
  .button {
    background: limegreen;
    color: white;
    font-size: 75%;
    display: inline-block;
    padding: 0.6em 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Edit-TextBlock.vue